module.exports = __webpack_public_path__ + "img/g4.a76ce7dd.png";